import React from "react";
import { useTranslation } from "react-i18next";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import "./pagination.scss";

export default function PaginationComponent({
  documents,
  pagination,
  page,
  pageSelected,
}) {
  const { t } = useTranslation();
  const totalPages = Math.ceil(documents / pagination);
  const arr = [...Array(totalPages).keys()];

  // Ajustar límite de páginas según el ancho de pantalla
  const isMobile = window.innerWidth <= 768;
  let pageLimit = isMobile ? 5 : 10; // number of page links in pagination
  let start = 0; // starting page
  let end = pageLimit; // ending page

  // increment start page when current page is greater than 5
  if (pageSelected - 1 >= 0) {
    start = pageSelected - (isMobile ? 1 : 3);
  }

  // if reaching end of pagination stop increment
  if (start + pageLimit >= totalPages) {
    start = totalPages - pageLimit;
  }

  // increment end page when current + 5 exceeds page limit
  if (pageSelected + (isMobile ? 1 : 3) >= pageLimit) {
    end = pageSelected + (isMobile ? 2 : 4);
    pageLimit = end;
    if (totalPages <= pageLimit) {
      pageLimit = totalPages;
    }
  }

  if (documents === 0) {
    return null;
  }

  return (
    <Pagination className="custom-pagination-container">
      <PaginationItem disabled={pageSelected === 0} className="pagination-item">
        <PaginationLink
          className="pagination-link pagination-link--prev"
          onClick={() => page(parseInt(pageSelected) - 1)}
        >
          <span className="hide-mobile">{t("Anterior")}</span>
          <span className="show-mobile">‹</span>
        </PaginationLink>
      </PaginationItem>
      {arr.map((e) => {
        if (e >= start && e < end && totalPages > 7 && pageSelected > 2) {
          return (
            <PaginationItem active={e === pageSelected} key={e} className="pagination-item">
              <PaginationLink
                className={`pagination-link ${
                  pageSelected === e && "pagination-link--active"
                }`}
                onClick={(ev) =>
                  ev.target.innerText === "..."
                    ? null
                    : page(parseInt(ev.target.innerText) - 1)
                }
              >
                {start + 2 === e + 1
                  ? "..."
                  : end - 1 === e + 1 && e + 1 !== totalPages
                  ? "..."
                  : start + 1 === e + 1
                  ? 1
                  : end === e + 1
                  ? totalPages
                  : e + 1}
              </PaginationLink>
            </PaginationItem>
          );
        } else if (
          e >= start &&
          e < end &&
          totalPages > 7 &&
          pageSelected < 3
        ) {
          return (
            <PaginationItem active={e === pageSelected} key={e} className="pagination-item">
              <PaginationLink
                className={`pagination-link ${
                  pageSelected === e && "pagination-link--active"
                }`}
                onClick={(ev) =>
                  ev.target.innerText === "..."
                    ? null
                    : page(parseInt(ev.target.innerText) - 1)
                }
              >
                {end - 1 === e + 1 && e + 1 !== totalPages
                  ? "..."
                  : start + 1 === e + 1
                  ? 1
                  : end === e + 1
                  ? totalPages
                  : e + 1}
              </PaginationLink>
            </PaginationItem>
          );
        } else if (totalPages < 8) {
          return (
            <PaginationItem active={e === pageSelected} key={e} className="pagination-item">
              <PaginationLink
                className={`pagination-link ${
                  pageSelected === e && "pagination-link--active"
                }`}
                onClick={(ev) => {
                  page(parseInt(ev.target.innerText) - 1);
                }}
              >
                {e + 1}
              </PaginationLink>
            </PaginationItem>
          );
        } else {
          return null;
        }
      })}
      <PaginationItem
        disabled={pageSelected + 1 === totalPages}
        className="pagination-item"
        onClick={() =>
          pageSelected + 1 < totalPages && page(parseInt(pageSelected) + 1)
        }
      >
        <PaginationLink className="pagination-link pagination-link--next">
          <span className="hide-mobile">{t("Siguiente")}</span>
          <span className="show-mobile">›</span>
        </PaginationLink>
      </PaginationItem>
    </Pagination>
  );
}